import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function docflowReducer() {
    return combineReducers({
        EDocPers_Get: createItemReducer("EDDocList", "EDocPers.Get", false),
        EDocPers_CreateSig: createItemReducerParams("EDDocList", "EDocPers.CreateSig"),
        EDoc_SignForPO: createItemReducer("EDDocList", "EDoc.SignForPO", false),
        EDoc_ListForPO: createItemReducer("EDDocList", "EDoc.ListForPO", false),
        EDoc_ListForPO_Params: createItemReducerParams("EDDocList", "EDoc.ListForPO"),
        EDoc_GetDoc: createItemReducer("EDDocList", "EDoc.GetDoc", false),
        EDocAsk_Save: createItemReducer("EDDocList", "EDocAsk.Save", false),
        EDocAsk_Save_Params: createItemReducerParams("EDDocList", "EDocAsk.Save"),

        AgreePers_ListForPO: createItemReducer("EDDocList", "AgreePers.ListForPO"),
        AgreePers_ListForPO_Params: createItemReducerParams("EDDocList", "AgreePers.ListForPO"),
        AgreePers_SignForPO: createItemReducer("EDDocList", "AgreePers.SignForPO"),
        AgreePersAsk_SaveAsk: createItemReducer("EDDocList", "AgreePersAsk.SaveAsk"),
        AgreePersAsk_SaveAsk_Params: createItemReducerParams("EDDocList", "AgreePersAsk.SaveAsk"),
        AgreePers_GetSignAllForPO: createItemReducer("EDDocList", "AgreePers.GetSignAllForPO"),
        AgreePers_SignAllForPO: createItemReducer("EDDocList", "AgreePers.SignAllForPO"),
        IllnessList_List_PO:createItemReducer("EDDocList", "IllnessList.List_PO"),
        IllnessList_List_PO_Params: createItemReducerParams("EDDocList", "IllnessList.List_PO"),
        IllnessListAsk_SaveAsk: createItemReducer("EDDocList", "IllnessListAsk.SaveAsk"),
        IllnessListAsk_SaveAsk_Params: createItemReducerParams("EDDocList", "IllnessListAsk.SaveAsk")
    });
}